module.exports = __webpack_public_path__ + "img/DISCOVER_60x36.9c7ab725.jpg";